{
let records = [];
let fields = [];
if (window.switch_type === "Data Center Switches") {
	fields = ["Interface", "Management Port", "Forwarding Rate", "Switching Capacity", "Fan", "Installations","Dimensions", 
			  "Full Weight", "Operating Temperature", "Storage Temperature"];
} else if (window.switch_type === "Enterprise Switches" || window.switch_type === "Industrial Switches") {
	fields = ["Interface", "Management Port", "Mac Address Table Size", "PoE Standard", "Forwarding Rate", "Switching Capacity", 
			  "PoE Budget", "Installations", "Dimensions", "Operating Temperature", "Storage Temperature"];
}

console.log(window.switch_type)
const query = new URLSearchParams({
	limit: 100,
	where: `(Product Line, eq, ${window.switch_type.replace("es", "")})`
});

// Fetch
async function getRecords(queries) {
	try {
		const response = await fetch(`https://nocodb-proxy.sharon-leo.workers.dev/records?${queries.toString()}`);
		if (!response.ok) {
			throw new Error("Network error - unable to retrieve records");
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error(error);
		return -1;
	}
}


// Records
function createHead(record) {
	const newHead = document.createElement("div");
	newHead.innerHTML = record["html"];
	newHead.setAttribute("value", record["name"].substring(record["name"].indexOf("AurCore") + 8, record["name"].indexOf(" | ")));
	
	return newHead
}

function addHead(product, header, i) {
	const newTHead = document.createElement("th");
	newTHead.classList.add("head");
	product.setAttribute("data-switch-num", i+1);
	newTHead.appendChild(product);
	header.appendChild(newTHead);
}

function setOptions(rows) {
	let products = []
	records = Object.entries(rows)[0][1];

	window.switch_products.forEach(record => {
		products.push(createHead(record));
	});

	const header = document.getElementById("product-head")
	products.forEach((product, i) => {
		addHead(product, header, i);
		fillData(product);
	});
}


// Fields
function createRow(field, numCols) {
	const newRow = document.createElement("tr");
	const newData = document.createElement("td");
	const empty = document.createElement("td");

	newData.innerHTML = field;
	newData.id = field.toLowerCase().replaceAll(" ", "-");
	newData.classList.add("field");


	newRow.classList.add("row", "data-row");
	newRow.appendChild(newData);

	empty.classList.add("data");
	empty.setAttribute("data-field", field.replaceAll(" ", "-"));
	for (let i = 1; i <= numCols; i++) {
		const newCell = empty.cloneNode(true);
		newCell.classList.add(`switch-${i}`);
		newRow.appendChild(newCell);
	}
	
	return newRow;

}

function setTable(numCols) {
	let tableRow = [];
	fields.forEach(field => {
		tableRow.push(createRow(field, numCols));
	});

	const table = document.getElementById("spec-table");
	tableRow.forEach(entry => {
		table.appendChild(entry)
	});
}


// Data retrieval
(async () => {
	const rows = await getRecords(query);
	if (rows !== -1) {
		setTable(window.switch_products.length);
		setOptions(rows);
	} else {
		document.getElementById("fallback-wrap").style.display = "block";
	}
})();

function fillData(product) {
	let data = "";
	records.every(record => {
		if (record["fields"]["SKU"] === product.getAttribute("value")) {
			data = record.fields;
			return false;
		}
		return true;
	});

	const rows = document.querySelectorAll(`.switch-${product.getAttribute("data-switch-num")}`);
	rows.forEach(row => {
		row.innerHTML = data[row.getAttribute("data-field").replaceAll("-", " ")];
		if (row.innerHTML === "") {
			row.innerHTML = "/";
			row.classList.add("no-data");
		} else if ("no-data" in row.classList) {
			row.classList.remove("no-data");
		}
	});
}
}